import React, {useEffect, useState} from 'react'
import {Button, Form, Input, message, Modal, Popconfirm} from "antd"
import parseToken from "../../../../../../helpers/parseToken"
import {
    addTenantShortPhone,
    getShortPhoneSeq,
    updateTenantShortPhone
} from "../../../../../../services/api/apiCustomerHub"

const VirtualNumberModal = (props) => {
    const [formUpdateVirtualNumber] = Form.useForm()
    const {tenantId, isEdit, isOpen, selectItem, onClose, onGetAgain} = props;
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)

    const _fetchVirtualNumber = async () => {
        try {
            const response = await getShortPhoneSeq(decodeToken.sub)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            formUpdateVirtualNumber.setFieldValue('shortPhone', data)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onAddVirtualNumber = async () => {
        setLoading(true)

        try {
            const payload = {
                tenantId,
                shortPhone: formUpdateVirtualNumber.getFieldValue('shortPhone'),
                ipIn: formUpdateVirtualNumber.getFieldValue('ipIn'),
                ipOut: formUpdateVirtualNumber.getFieldValue('ipOut'),
            }

            const response = await addTenantShortPhone(decodeToken.sub, payload)

            setLoading(false)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Thêm mới thành công!')
            onGetAgain()
            onClose()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _onUpdateVirtualNumber = async () => {
        setLoading(true)
        try {
            const payload = {
                shortPhone: formUpdateVirtualNumber.getFieldValue('shortPhone'),
                ipIn: formUpdateVirtualNumber.getFieldValue('ipIn'),
                ipOut: formUpdateVirtualNumber.getFieldValue('ipOut'),
            }

            const response = await updateTenantShortPhone(decodeToken.sub, selectItem.id, payload)

            setLoading(false)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Cập nhật thành công!')
            onGetAgain()
            onClose()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    useEffect(() => {
        if (selectItem.id && isEdit) {
            formUpdateVirtualNumber.setFieldsValue({
                shortPhone: selectItem.shortPhone,
                ipIn: selectItem.ipIn,
                ipOut: selectItem.ipOut,
            })
        }
        // eslint-disable-next-line
    }, [selectItem.id]);

    useEffect(() => {
        if (isOpen && !isEdit) {
            _fetchVirtualNumber()
        }
        // eslint-disable-next-line
    }, [isOpen]);

    return (
        <Modal
            className='ModalCustom2'
            title={isEdit ? "Sửa số ảo" : "Thêm số ảo"}
            maskClosable={false}
            open={isOpen}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={onClose} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" htmlType='submit' form='updateFee' loading={loading}>
                        {isEdit ? 'Sửa' : 'Thêm'}
                    </Button>
                </div>
            ]}
        >
            <Form
                layout="vertical"
                className='FormEdit'
                form={formUpdateVirtualNumber}
                id='updateFee'
                onFinish={isEdit ? _onUpdateVirtualNumber : _onAddVirtualNumber}
            >
                <Form.Item
                    className='FormField'
                    name='shortPhone'
                    label={<label className="Label">Số ảo<span className="Required">*</span></label>}
                    rules={[
                        {
                            required: true,
                            message: 'Số ảo là bắt buộc'
                        }
                    ]}
                >
                    <Input placeholder='Nhập số ảo'/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    name='ipIn'
                    label={<label className="Label">IP đón cuộc gọi vào</label>}
                >
                    <Input placeholder='Nhập IP đón cuộc gọi vào'/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    name='ipOut'
                    label={<label className="Label">Danh sách IP gọi ra<span className="Required">*</span></label>}
                    rules={[
                        {
                            required: true,
                            message: 'Danh sách IP gọi ra là bắt buộc'
                        }
                    ]}
                >
                    <Input placeholder='Nhập danh sách IP gọi ra (cách nhau dấu ,)'/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default VirtualNumberModal
